/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subscription_Walkthrough_P1_Content_Triple_CoinInputs */

const en_subscription_walkthrough_p1_content_triple_coin = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Triple_CoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]"><span style="[%2$s]">Triple</span> focus coin rewards</span>`)
};

const ar_subscription_walkthrough_p1_content_triple_coin = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Triple_CoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]"><span style="[%2$s]">ثلاثية</span> مكافآت عملة التركيز</span>`)
};

const de_subscription_walkthrough_p1_content_triple_coin = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Triple_CoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]"><span style="[%2$s]">Dreifach</span> fokus-Münzen-Belohnungen</span>`)
};

const es_subscription_walkthrough_p1_content_triple_coin = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Triple_CoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]"><span style="[%2$s]">Recompensa triple</span> de monedas de concentración</span>`)
};

const fr_subscription_walkthrough_p1_content_triple_coin = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Triple_CoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">Récompenses en pièces <span style="[%2$s]">triplées</span></span>`)
};

const it_subscription_walkthrough_p1_content_triple_coin = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Triple_CoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">Ricompense in monete di concentrazione <span style="[%2$s]">triple</span></span>`)
};

const ja_subscription_walkthrough_p1_content_triple_coin = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Triple_CoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">獲得コインが<span style="[%2$s]">3倍</span></span>`)
};

const ko_subscription_walkthrough_p1_content_triple_coin = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Triple_CoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">포커스 코인 리워드 <span style="[%2$s]">3배</span></span>`)
};

const pt_br_subscription_walkthrough_p1_content_triple_coin = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Triple_CoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">Recompensas de foco com o <span style="[%2$s]">triplo</span> de moedas</span>`)
};

const ru_subscription_walkthrough_p1_content_triple_coin = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Triple_CoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]"><span style="[%2$s]">Тройное</span> вознаграждение за фокусировку в виде монет</span>`)
};

const th_subscription_walkthrough_p1_content_triple_coin = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Triple_CoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">รางวัลเหรียญการโฟกัส<span style="[%2$s]">สามเท่า</span></span>`)
};

const tr_subscription_walkthrough_p1_content_triple_coin = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Triple_CoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]"><span style="[%2$s]">Üç kat</span> odaklanma jeton ödülü</span>`)
};

const zh_cn_subscription_walkthrough_p1_content_triple_coin = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Triple_CoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">专注<span style="[%2$s]">金币奖励 3 倍</span></span>`)
};

const zh_tw_subscription_walkthrough_p1_content_triple_coin = /** @type {(inputs: Subscription_Walkthrough_P1_Content_Triple_CoinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<span style="[%1$s]">專注<span style="[%2$s]">金幣獎勵 3 倍</span></span>`)
};

/**
* | output |
* | --- |
* | "<span style=\"[%1$s]\"><span style=\"[%2$s]\">Triple</span> focus coin rewards</span>" |
*
* @param {Subscription_Walkthrough_P1_Content_Triple_CoinInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const subscription_walkthrough_p1_content_triple_coin = /** @type {((inputs?: Subscription_Walkthrough_P1_Content_Triple_CoinInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subscription_Walkthrough_P1_Content_Triple_CoinInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_subscription_walkthrough_p1_content_triple_coin(inputs)
	if (locale === "ar") return ar_subscription_walkthrough_p1_content_triple_coin(inputs)
	if (locale === "de") return de_subscription_walkthrough_p1_content_triple_coin(inputs)
	if (locale === "es") return es_subscription_walkthrough_p1_content_triple_coin(inputs)
	if (locale === "fr") return fr_subscription_walkthrough_p1_content_triple_coin(inputs)
	if (locale === "it") return it_subscription_walkthrough_p1_content_triple_coin(inputs)
	if (locale === "ja") return ja_subscription_walkthrough_p1_content_triple_coin(inputs)
	if (locale === "ko") return ko_subscription_walkthrough_p1_content_triple_coin(inputs)
	if (locale === "pt_br") return pt_br_subscription_walkthrough_p1_content_triple_coin(inputs)
	if (locale === "ru") return ru_subscription_walkthrough_p1_content_triple_coin(inputs)
	if (locale === "th") return th_subscription_walkthrough_p1_content_triple_coin(inputs)
	if (locale === "tr") return tr_subscription_walkthrough_p1_content_triple_coin(inputs)
	if (locale === "zh_cn") return zh_cn_subscription_walkthrough_p1_content_triple_coin(inputs)
	return zh_tw_subscription_walkthrough_p1_content_triple_coin(inputs)
});